module.exports = __webpack_public_path__ + "media/whats_your_status_series_prepare_for_the_big_internship_interview/crm_internships_sidebar_02-27f0f702.jpg";